import { render, staticRenderFns } from "./CustomerAccount.vue?vue&type=template&id=57def56a&scoped=true"
import script from "./CustomerAccount.vue?vue&type=script&lang=js"
export * from "./CustomerAccount.vue?vue&type=script&lang=js"
import style0 from "./CustomerAccount.vue?vue&type=style&index=0&id=57def56a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57def56a",
  null
  
)

export default component.exports